export const swapInProgress = { current: false };
